import {
    BEST_PHOTO_TOOLTIP_ID,
    BEST_PHOTO_VIEWER_TOOLTIP_ID,
    REMOVE_ALL_DUPLICATES_TOOLTIP_ID,
} from 'reactApp/modules/duplicates/duplicates.constants';
import { getDuplicatesGroupsTotal, getDuplicatesListCount, getDuplicatesListSize } from 'reactApp/modules/duplicates/duplicates.selectors';
import type { IDuplicatesPreviewItem } from 'reactApp/modules/duplicates/duplicates.types';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { UrlBuilder } from 'reactApp/modules/urlBuilder/UrlBuilder';
import type { RootState } from 'reactApp/store';

export const getRemoveAllDuplicatesTooltipShown = () => Boolean(storeHelper.getValue(REMOVE_ALL_DUPLICATES_TOOLTIP_ID));

export const getBestPhotoTooltipShown = () => Boolean(storeHelper.getValue(BEST_PHOTO_TOOLTIP_ID));

export const getBestPhotoViewerTooltipShown = () => Boolean(storeHelper.getValue(BEST_PHOTO_VIEWER_TOOLTIP_ID));

export const getDuplicatePreviewUrl = (item: IDuplicatesPreviewItem) => {
    const urlBuilder = new UrlBuilder();

    const urlBuilderParams = { path: item?.path, code: 'xw25' };

    return urlBuilder.getThumbUrl(urlBuilderParams);
};

export const getDuplicatesAnalytic = (state: RootState) => {
    const duplicatesGroupTotalCount = getDuplicatesGroupsTotal(state);
    const duplicatesListSize = getDuplicatesListSize(state);
    const duplicatesListCount = getDuplicatesListCount(state);

    return { groups_count: duplicatesGroupTotalCount, size_files: duplicatesListSize, count_files: duplicatesListCount };
};
